import { Box, Grid, Typography } from '@mui/material';
import { FC } from 'react';

export const INIT_DATA = {};

interface IProps {
  data: any;
  register: any;
  errors: any;
  control: any;
}

const NoteForm: FC<any> = ({ data, register, errors, control }: IProps) => {
  return (
    <Grid container spacing={9}>
      {/* Left side */}
      <Grid item md={6}>
        <Box display="flex" flexDirection="column" flexGrow={1}>
          <Box display="flex">
            <Typography variant="legend">Note 1st section</Typography>
          </Box>
          <Box display="flex" flexDirection="column">
            Note 1st section content
          </Box>
        </Box>
      </Grid>
      {/* Right side */}
      <Grid item md={6}>
        <Box display="flex" flexDirection="column" flexGrow={1}>
          <Box display="flex">
            <Typography variant="legend">Note 2nd section</Typography>
          </Box>
          <Box display="flex" flexDirection="column">
            Note 2nd section content
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default NoteForm;
